export const module = {
  info: {
    name: 'voip-generate-live-user-active-calls',
    caption: 'voip generate live user active calls',
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    notAllowedProfiles: [],
    topSeparator: false,
    caption: 'Live Calls',
    icon: 'el-icon-phone-outline',
    routeName: 'module->voip-generate-live-user-active-calls->view',
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-generate-live-user-active-calls->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-generate-live-user-active-calls->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
